import React from 'react'

const Backend = () => {
    return (
        <div className='skills_content'>
            <h3 className="skills_title">Backend developer</h3>

            <div className="skills_box">
                <div className="skills_group">
                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">PHP</h3>
                            <span className="skills_level">Intermediate</span>
                        </div>
                    </div>

                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">Node Js</h3>
                            <span className="skills_level">Intermediate</span>
                        </div>
                    </div>

                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">Express Js</h3>
                            <span className="skills_level">Basic</span>
                        </div>
                    </div>
                </div>

                <div className="skills_group">
                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">MySQL</h3>
                            <span className="skills_level">Intermediate</span>
                        </div>
                    </div>



                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">SQL</h3>
                            <span className="skills_level">Intermediate</span>

                        </div>
                    </div>


                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">MangoDB</h3>
                            <span className="skills_level">Intermediate</span>

                        </div>
                    </div>
                </div>
            </div>










        </div>
    )
}

export default Backend
